import { render } from "./GenericActionModal.vue?vue&type=template&id=83c242e2&scoped=true"
import script from "./GenericActionModal.vue?vue&type=script&lang=js"
export * from "./GenericActionModal.vue?vue&type=script&lang=js"

import "./GenericActionModal.vue?vue&type=style&index=0&id=83c242e2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-83c242e2"]])

export default __exports__